import { useApplicantAPI } from "@certn/api/src/useApplicantAPI";
import {
  CheckboxFormikField,
  CheckboxGroupFormikField,
  Grid,
  GridItem,
} from "@certn/cascadia-react";
import { slugify } from "@certn/utils";
import { Field } from "formik";
import { useTranslation } from "react-i18next";

import { FormModal } from "../FormModal";

type RequestTypeModalProps = {
  onNext: () => void;
  onClose: () => void;
};

export function RequestTypeModal({ onNext, onClose }: RequestTypeModalProps) {
  const { t } = useTranslation();
  const { data: requestTypes } = useApplicantAPI(
    "/api/internal/applicant/request-account-data/options/"
  );

  return (
    <FormModal
      title={t("Personal data request")}
      onSubmit={onNext}
      onCancel={onClose}
      continueText={t("Next")}
      secondaryText={t("Cancel")}
      variant="success"
    >
      <Grid>
        <GridItem>
          <Field
            as={CheckboxGroupFormikField}
            label={t("Please select the request type")}
            name="request_types"
            isRequired
          >
            {requestTypes?.map(({ value, more_info, description }) => {
              // Note: below can be removed when constants in BE are updated (RequestAccountDataOptions)
              if (description === "Delete my data") {
                description = t("Delete my data and account");
              }
              return (
                <CheckboxFormikField
                  isCard
                  name={value}
                  key={value}
                  value={value}
                  description={more_info}
                  testID={`personal-data-request-modal-${slugify(description)}`}
                >
                  {description}
                </CheckboxFormikField>
              );
            })}
          </Field>
        </GridItem>
      </Grid>
    </FormModal>
  );
}
